import {FC, useEffect, useState} from 'react'
import axios from 'axios'
import {useAuth} from '../../modules/auth'

type Summary = {
  generatedAt: string
  horizonDays: number
  requestCount: number
  plannedQuestionCount: number
  writtenQuestionCount: number
  controlCompletedCount: number
  missingQuestionCount: number
  controlIncompleteCount: number
  smsAttemptCount: number
  smsSuccessCount: number
  smsFailedCount: number
  smsSuccessRate: number
}

const cards = [
  {key: 'requestCount', label: 'Yaklaşan Talep', color: '#084298', background: '#e7f1ff', border: '#9ec5fe'},
  {key: 'plannedQuestionCount', label: 'Planlanan Soru', color: '#055160', background: '#cff4fc', border: '#9eeaf9'},
  {key: 'writtenQuestionCount', label: 'Yazılan Soru', color: '#0f5132', background: '#d1e7dd', border: '#a3cfbb'},
  {key: 'controlCompletedCount', label: 'Kontrolü Tamamlanan', color: '#0f5132', background: '#d1e7dd', border: '#a3cfbb'},
  {key: 'missingQuestionCount', label: 'Eksik Soru', color: '#842029', background: '#f8d7da', border: '#f1aeb5'},
  {key: 'controlIncompleteCount', label: 'Kontrol Bekleyen', color: '#664d03', background: '#fff3cd', border: '#ffe69c'},
] as const

const AdminCurrentSummary: FC = () => {
  const {currentUser} = useAuth()
  const roleName = currentUser?.roleName ?? currentUser?.RoleName ?? ''
  const isAdmin = roleName.trim().toUpperCase() === 'ADMIN'
  const [summary, setSummary] = useState<Summary | null>(null)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!isAdmin) return

    axios.get<Summary>(`${process.env.REACT_APP_API_URL}/AdminDashboard/DailySummary`)
      .then((response) => setSummary(response.data))
      .catch(() => setError(true))
  }, [isAdmin])

  if (!isAdmin) return null

  return (
    <div className='card mb-8'>
      <div className='card-header border-0 pt-5 d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-2'>
        <div>
          <h2 className='card-title fw-bolder text-gray-900 mb-1'>Güncel Durum Özeti</h2>
          <div className='text-gray-700 fs-6'>Günlük e-postadaki 15 günlük talep ve son 24 saatlik SMS bilgileri.</div>
        </div>
        {summary && <div className='text-gray-700 fs-7 fw-semibold text-nowrap'>Güncellendi: {new Date(summary.generatedAt).toLocaleString('tr-TR')}</div>}
      </div>
      <div className='card-body pt-4'>
        {error && <div className='alert alert-warning'>Güncel özet şu anda alınamadı.</div>}
        {!summary && !error && <div className='text-muted'>Özet hazırlanıyor...</div>}
        {summary && (
          <>
            <div className='row g-4 mb-5'>
              {cards.map((card) => (
                <div className='col-12 col-sm-6 col-lg-4 col-xxl-2' key={card.key}>
                  <div
                    className='rounded border p-4 h-100'
                    style={{backgroundColor: card.background, borderColor: card.border}}
                  >
                    <div className='fs-2 fw-bolder' style={{color: card.color}}>{summary[card.key]}</div>
                    <div className='fs-7 fw-semibold' style={{color: card.color}}>{card.label}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className='d-flex flex-wrap gap-5 border-top pt-4 text-gray-700 fs-6'>
              <span>SMS denemesi: <strong className='text-dark'>{summary.smsAttemptCount}</strong></span>
              <span>Başarılı: <strong style={{color: 'var(--nosi-success-text)'}}>{summary.smsSuccessCount}</strong></span>
              <span>Başarısız: <strong style={{color: 'var(--nosi-danger-text)'}}>{summary.smsFailedCount}</strong></span>
              <span>Başarı oranı: <strong className='text-dark'>%{summary.smsSuccessRate.toFixed(1)}</strong></span>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default AdminCurrentSummary
